import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    handleSubmit() {
        const btn = this.element.querySelector('[type="submit"]')
        if (!btn) return
        const label = btn.dataset.loadingLabel || 'Saving...'
        btn.disabled = true
        btn.textContent = label
    }
}
